
import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";




const storeApi = (set) => ({

    totalPlanillas: 0,
    datosPlanilla: {},
    
    items: [],
    formValues: {
        vehiculo: '',
        conductor: '',
        cliente: '',
        pesador: '',
        horaInicio: '',
        horaFinal: '',
        descuento: 'VENTA',
        cantidad: '',
        valorKilo: '',
        fecha: '',
        cargueros: [], 
        acuerdo: '', 
        valorAcordado: '',
        observacion: ''
    },


    // FUNCIÓN PARA ACTUALIZAR VALORES INDIVIDUALES
    updateFormValue: ({ name, value }) =>
        set((state) => ({ formValues: { ...state.formValues, [name]: value },
    })),



    // LIMPIAR FORMULARIO
    resetForm: () =>
        set(() => ({
            formValues: {
                vehiculo: '',
                conductor: '',
                cliente: '',
                pesador: '',
                horaInicio: '',
                horaFinal: '',
                descuento: 'VENTA',
                cantidad: '',
                valorKilo: '',
                fecha: '',
                cargueros: [],
                acuerdo: '',
                valorAcordado: '',
                observacion: '',
            },
        items: [],
    })),


    // AGREGAR ITEM DE DESTARES
    addItem: () =>
        set((state) => {
        const newId = state.items.length + 1;
        const newItem = {
            _id: newId,
            huacales: '',
            avesXhuacal: '',
            pesoAvesHuacal: '',
            destare: 0,
        };
        return { items: [newItem, ...state.items] };
    }),


    // ACTUALIZAR ITEM DE DESTARES
    updateItemField: (id, field, value) =>
        set((state) => ({
        items: state.items.map((item) =>
            item._id === id ? { ...item, [field]: value } : item
        ),
    })),


    // ELIMINAR ITEM DE DESTARES
    removeItem: (id) =>
        set((state) => ({
            items: state.items.filter((item) => item._id !== id),
    })),


});





export const usePlanillassStore = create()(
    devtools(
        persist(storeApi, {
            name: 'planilla-form',
            partialize: (state) => ({ formValues: state.formValues, items: state.items })
        })
    )
)
